import React, { Component } from "react";
import PropTypes from "prop-types";
import { BellFilled } from '@ant-design/icons';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap';
import {getNotifications, getMemberNotifications, updateUser, deleteMemberNotifications} from "../../api";
import Notification from "./notification";

class NotificationDropdown extends Component {

  constructor(props) {
    super(props);

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.createNotificationItems = this.createNotificationItems.bind(this);
    this.refreshMemberNotifications = this.refreshMemberNotifications.bind(this);
    this.findDelNotifications = this.findDelNotifications.bind(this);

    this.state = {
      dropdownOpen: false,
      notifications : [],
      deleteNotifications : [],
      deletedIds: [],
      memberNotifications : []
    }
  }

  async toggleDropdown() {
    this.findDelNotifications();
    let { deletedIds } = this.state;
    if(deletedIds && deletedIds.length > 0){
      await deleteMemberNotifications(deletedIds);
      const memberNotifications = await getMemberNotifications();
      const updatedMemberNotifications = memberNotifications.map(memberNotification => {
        memberNotification.selected = false;
        return memberNotification;
      });
      this.setState({ memberNotifications : updatedMemberNotifications } );
    }

    this.setState(previousState => ({
      dropdownOpen: !previousState.dropdownOpen
    }));
  }

  findDelNotifications() {
    let { memberNotifications } = this.state;
    let deletedIds = [];
    if(memberNotifications && memberNotifications.length > 0) {
      let notifications = memberNotifications.filter(memberNotification => {
        if (memberNotification.selected === true) {
          return memberNotification;
        }
      });

      if (notifications && notifications.length > 0) {
        notifications.forEach(function (notification) {
          deletedIds.push(notification.id);
        });
      }

      this.setState({deletedIds});
    }
  }

  async componentDidMount(){
      const notifications = await getNotifications();
    const memberNotifications = await getMemberNotifications();
      this.setState({ notifications } );
    let updatedMemberNotifications = [];
    if(memberNotifications && memberNotifications.length > 0) {
      updatedMemberNotifications = memberNotifications.map(memberNotification => {
        memberNotification.selected = false;
        return memberNotification;
      });
    }


    this.setState({ memberNotifications : updatedMemberNotifications } );
    //await updateUser();
  }

  componentDidUpdate(prevProps){
    if(this.props.context) {
      const {refreshNotifications, activeProject, refreshMemberNotifications} = this.props.context.state;
      if(refreshNotifications && !prevProps.context.state.refreshNotifications){
        this.props.context.setRefreshNotifications(false);
        this.updateNotifications(activeProject);       
      }
      if(refreshMemberNotifications && !prevProps.context.state.refreshMemberNotifications){
        this.props.context.setRefreshMemberNotifications(false);
        this.getMemberNotifications();
      }
      
    }
  }

  async getMemberNotifications(){
    let memberNotifications = await getMemberNotifications(); 
    memberNotifications = memberNotifications.map(memberNotification => {
      memberNotification.selected = false;
      return memberNotification;
    });  
    this.setState({ memberNotifications } );
  }

  async updateNotifications(activeProject){
    let { memberNotifications } = this.state;
    let deletedIds = [];
    memberNotifications.forEach(memberNotification => {
      if (memberNotification.projectId === activeProject.id) {
         deletedIds.push(memberNotification.id);
      }
    });
    const notifications = await getNotifications();
    if(deletedIds && deletedIds.length > 0){
     await deleteMemberNotifications(deletedIds);
      memberNotifications = await getMemberNotifications();   
      memberNotifications = memberNotifications.map(memberNotification => {
        memberNotification.selected = false;
        return memberNotification;
      });    
    }
    this.setState({ memberNotifications, notifications } );
  }

  refreshMemberNotifications(id){

    let { memberNotifications } = this.state;
    if(memberNotifications && memberNotifications.length > 0) {
      const updatedMemberNotifications = memberNotifications.map(memberNotification => {
        let updatedMemberNotification = {...memberNotification};
        if (updatedMemberNotification.id === id) {
          updatedMemberNotification = {
            ...updatedMemberNotification,
            ...{selected: !updatedMemberNotification.selected}
          };
        }
        return updatedMemberNotification;
      });
      this.setState({memberNotifications: updatedMemberNotifications});
    }
  }


  createNotificationItems() {
    const { notifications } = this.state;
    const { memberNotifications } = this.state;
    var notificationItems = [];
    for(var i = 0; i < notifications.length; i++) {
      if(notifications[i].params.projectParentId){
        notifications[i].params.projectId = notifications[i].params.projectParentId;
      }
      notificationItems.push(
        <DropdownItem style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
          <Notification
            title={notifications[i].params.station}
            taskType={notifications[i].type}
            by={notifications[i].params.requestedBy}
            assetId={notifications[i].params.assetId}
            assetName={notifications[i].params.assetName}
            projectId={notifications[i].params.projectId}
            desc={notifications[i].description}
            projectStatus={notifications[i].params.projectStatus}
            formId={notifications[i].params.formId}
            formName={notifications[i].params.formName}
            taskSubType={notifications[i].params.taskSubType}
            action={notifications[i].action}
            section={notifications[i].params.sectionName}
          />
        </DropdownItem>
      );

      if (i < notifications.length - 1) {
        notificationItems.push(<DropdownItem divider />);
      }
    }


    for(var j = 0; j < memberNotifications.length; j++) {

       notificationItems.push(
          <DropdownItem header style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            <Notification
                title={memberNotifications[j].station}
                taskType="MEMEBER_NOTIFICATION"
                desc={memberNotifications[j].description}
                projectId={memberNotifications[j].projectId}
                projectStatus={memberNotifications[j].projectStatus}
                NotificationId={memberNotifications[j].id}
                refreshMemberNotifications = {this.refreshMemberNotifications}
                selected = {memberNotifications[j].selected}
           />
          </DropdownItem>
      );

      if (j < memberNotifications.length - 1) {
        notificationItems.push(<DropdownItem divider />);
      }
    }

    return(notificationItems);
  }

  render() {
    let notificationItems = this.createNotificationItems();
    return (
      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown} inNavbar>
        <DropdownToggle color="white">
          <BellFilled /><Badge color="danger" style={{ color: "white" }}>{this.state.notifications.length+this.state.memberNotifications.length}</Badge>
        </DropdownToggle>
        <DropdownMenu right style={{ width: "450px", height: "380px", overflow: "scroll", borderColor: "#0ca0da"}}>
          {notificationItems}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

NotificationDropdown.propTypes = {
  notifications: PropTypes.array
}

export default NotificationDropdown;
